import { render, staticRenderFns } from "./RowChildCount.vue?vue&type=template&id=bf44e9bc&scoped=true"
import script from "./RowChildCount.vue?vue&type=script&lang=js"
export * from "./RowChildCount.vue?vue&type=script&lang=js"
import style0 from "./RowChildCount.vue?vue&type=style&index=0&id=bf44e9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf44e9bc",
  null
  
)

export default component.exports